var exports = {
  "j0": "DirectMessageLayout.module__dmLayoutContainer___ZlNiQn",
  "eN": "DirectMessageLayout.module__dmLayoutContainerFullscreen___ZlNiQn",
  "Il": "DirectMessageLayout.module__dmListColumn___ZlNiQn",
  "qy": "DirectMessageLayout.module__contentColumn___ZlNiQn",
  "$f": "DirectMessageLayout.module__contentColumnFullscreen___ZlNiQn",
  "YE": "DirectMessageLayout.module__contentInner___ZlNiQn",
  "jk": "DirectMessageLayout.module__contentInnerFullscreen___ZlNiQn",
};

module.exports = exports;
